import { render, staticRenderFns } from "./page_row.vue?vue&type=template&id=2e7754ac&scoped=true&lang=pug"
import script from "./page_row.vue?vue&type=script&lang=js"
export * from "./page_row.vue?vue&type=script&lang=js"
import style0 from "./page_row.vue?vue&type=style&index=0&id=2e7754ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7754ac",
  null
  
)

export default component.exports